import { connect } from 'react-redux';
import Home from '../components/Home';
import { FETCH_NEWS_RT } from './../actions/home.actions';


const mapStateToProps = state => ({
    isLoading: state.home.isLoading,
    news: state.home.news
});

const mapDispatchToProps = (dispatch) => {
    dispatch(FETCH_NEWS_RT());
    return {};
};

const HomeContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Home);

export default HomeContainer;



// WEBPACK FOOTER //
// ./src/containers/Home.container.js